<template>
  <div id="OrderCreate">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col
          cols="3"
          class="d-none d-lg-block border-right border-warning pb-4 pt-2"
        >
          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <b-row>
            <b-col>
              <h2>แก้ไขใบพรีออร์เดอร์ {{formPre.trackPreorderCode}}</h2>
            </b-col>
            <b-col class="text-right">
              <b-button
                variant="warning"
                class="mb-1"
                @click="$router.push('/pod/OrderList')"
                pill
                >กลับสู่หน้ารายการ</b-button
              >
              <b-button
                variant="success"
                class="mb-1"
                @click="onSubmit"
                v-if="!checkCode"
                pill
                >แก้ไขใบพรีออร์เดอร์</b-button
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card title="รายละเอียด" class="my-2">
                <b-card-body class="p-0">
                  <b-card-text>
                    <b-row>
                      <b-col sm="6">
                        <label for="orderId" class="mb-1">หมายเลขคำสั่งซื้อ:</label>
                        <b-form-input
                          id="orderId"
                          class="mb-2"
                          v-model="formPre.orderCode"
                          type="text"
                        ></b-form-input>
                      </b-col>

                      <b-col sm="6">
                        <label for="shopChina" class="mb-1">แพลทฟอร์มที่สั่งซื้อ:</label>
                        <b-form-input
                          id="shopChina"
                          class="mb-2"
                          v-model="formPre.shopChina"
                          type="text"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="6">
                        <label for="orderId" class="mb-1">รหัสสมาชิก:</label>
                        <b-form-input
                          id="userCode"
                          class="mb-2"
                          v-model="formPre.userCode"
                          type="text"
                          placeholder="MP-XXX"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <label class="mb-1">หมายเลขจัดส่งพัสดุในจีน:</label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="6" v-for="(track, index) in formPre.trackCode" :key="index">
                        <b-input-group class="mb-2">
                          <b-form-input
                            :id="'trackCode-'+index"
                            v-model="formPre.trackCode[index]"
                            type="text"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button :disabled="formPre.trackCode.length <= 1" @click="formPre.trackCode.splice(index, 1)" variant="danger">ลบ</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-col>
                      <b-col sm="6">
                        <b-button variant="success" @click="formPre.trackCode.push('')"><f-icon icon="plus"></f-icon> เพิ่มหมายเลขจัดส่งพัสดุ</b-button>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card-body>
              </b-card>
              <b-card title="รายการสินค้าที่สั่ง" class="my-2">
                <b-card-body class="p-0">
                  <b-card-text>
                    <b-table class="m-0" hover outlined :fields="fieldsPre" :items="items" show-empty empty-text="กรุณากดที่ปุ่ม [เพิ่มลิ้งรายการสินค้า]">
                      <template #cell(indexItem)="data">
                        {{data.index + 1}}
                      </template>
                      <template #cell(picturePreorder)="data">
                        <b-img fluid width="50" center :src="data.item.picturePreorder" v-if="data.item.picturePreorder" :alt="`รูปสินค้า-${data.index}`"></b-img>
                      </template>
                      <template #cell(action)="data" v-if="userData.userType === 'A'">
                        <a v-b-tooltip.hover title="แก้ไขข้อมูล" @click="editDataTrack(data.item, data.index)">
                          <f-icon icon="edit"></f-icon>
                        </a>
                        <a v-b-tooltip.hover title="ลบข้อมูล" @click="items.splice(data.index, 1)">
                          <f-icon icon="trash-alt"></f-icon>
                        </a>
                      </template>
                      <!-- <template #custom-foot=" {} " v-if="userData.userType === 'A'">
                        <b-tr>
                          <b-td colspan="6" class="text-center p-0 py-2">
                            <b-button variant="success" v-b-modal.modalAddPreList><f-icon icon="plus"></f-icon> เพิ่มลิ้งรายการสินค้า</b-button>
                          </b-td>
                        </b-tr>
                      </template> -->
                    </b-table>
                  </b-card-text>
                  <!-- <b-card-text>
                    <b-row>
                      <b-col>
                        <label for="trackNote" class="mb-1">ราคาสินค้ารวม:</label>
                        <b-form-input
                          id="orderId"
                          class="mb-2"
                          v-model="formPre.amountPrice"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col>
                        <label for="orderId" class="mb-1">ราคาขนส่งในจีนรวม:</label>
                        <b-form-input
                          id="userCode"
                          class="mb-2"
                          v-model="formPre.amountShip"
                          type="number"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-card-text> -->
                </b-card-body>
              </b-card>

            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-modal id="modalAddPreList"
        @show="resetModal"
        @hidden="resetModal"
        hide-footer>
        <template #modal-title>
          เพิ่มรายการสินค้า
        </template>
        <div class="d-block">
          <label for="trackType" class="mb-1">ลำดับรายการ: {{ formProduct.index }}</label>
          <br />

          <label for="form_usercode" class="mb-1">Url สินค้า:</label>
          <b-form-input id="form_usercode" class="mb-2" autocomplete="off" v-model="formProduct.url" type="text" ></b-form-input>

          <label for="form_usercode" class="mb-1">หมายเหตุ (ระบุความต้องการ):</label>
          <b-form-input id="form_usercode" class="mb-2" autocomplete="off" v-model="formProduct.remark" type="text" ></b-form-input>

          <!-- <label for="form_usercode" class="mb-1">ราคาสินค้า:</label>
          <b-form-input id="form_usercode" class="mb-2" autocomplete="off" v-model="formProduct.price" type="number" min="0" ></b-form-input>

          <label for="form_usercode" class="mb-1">ราคาขนส่งในจีน:</label>
          <b-form-input id="form_usercode" class="mb-2" autocomplete="off" v-model="formProduct.ship" type="number" min="0" ></b-form-input> -->
        </div>
        <b-button class="mt-3" block @click="onAddOrder()">เพิ่มรายการสินค้า</b-button>
      </b-modal>

      <b-modal id="modalEditPreList" hide-footer>
        <template #modal-title>
          แก้ไขรายการสินค้า
        </template>
        <div class="d-block">
          <label for="trackType" class="mb-1">ลำดับรายการ: {{ formProductUpdate.index + 1 }}</label>
          <br />

          <label for="form_usercode" class="mb-1">Url สินค้า:</label>
          <b-form-input id="form_usercode" class="mb-2" autocomplete="off" v-model="formProductUpdate.url" type="text" ></b-form-input>

          <label for="form_usercode" class="mb-1">หมายเหตุ (ระบุความต้องการ):</label>
          <b-form-input id="form_usercode" class="mb-2" autocomplete="off" v-model="formProductUpdate.remark" type="text" ></b-form-input>

          <!-- <label for="form_usercode" class="mb-1">ราคาสินค้า:</label>
          <b-form-input id="form_usercode" class="mb-2" autocomplete="off" v-model="formProductUpdate.price" type="number" min="0" ></b-form-input>

          <label for="form_usercode" class="mb-1">ราคาขนส่งในจีน:</label>
          <b-form-input id="form_usercode" class="mb-2" autocomplete="off" v-model="formProductUpdate.ship" type="number" min="0" ></b-form-input> -->
        </div>
        <b-button class="mt-3" block @click="onEditOrder(formProductUpdate.index, formProductUpdate)">แก้ไข</b-button>
      </b-modal>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from "@/components/Menubar"; // เมนู
export default {
  name: "OrderCreate",
  components: {
    "left-menu": MenuBar,
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    await this.getDataUser();
    await this.getDataPreOrder(this.$route.query.trackPreorderCode)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  data() {
    return {
      userType: '',
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: '',
        userCode: '',
      },
      fieldsPre: [
        { key: 'indexItem', label: 'ลำดับ', tdStyle: { width: "10px" }, thStyle: { width: "10px" } },
        { key: 'picturePreorder', label: '', tdStyle: { width: "60px" }, thStyle: { width: "60px" }},
        { key: 'url', label: 'ลิ้งสินค้า' },
        { key: 'remark', label: 'หมายเหตุ' },
        // { key: 'action', label: 'จัดการ' },
      ],
      items: [
      ],
      formProduct: {
        url: '',
        remark: '',
      },
      formProductUpdate: {
        index: 0,
        url: '',
        remark: '',
      },
      formPre: {
        trackPreorderCode: '',
        orderCode: '',
        userCode: '',
        trackCode: [''],
      },
      checkCode: false,
      dataReady: true,
    };
  },
  methods: {
    onSubmit() {
      let form_update = [];
      this.items.forEach(item => {
        const data = {
          trackPreorderId: item.trackPreorderId,
          preorderCode: this.formPre.orderCode,
          shippingChinaCode: this.formPre.trackCode.join(', '),
          userCode: this.formPre.userCode,
          shopChina: this.formPre.shopChina,
          remark: item.remark,
          url: item.url,
          LAST_USER: this.userData.userName,
        }
        form_update.push(data)
      })


      console.log(form_update)
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Track_preorder/Track_preorder_update",
          form_update,
          {
            // headers: this.getHeaderAPI('Track_preorder_update', this.userData.userName),
            headers: this.getHeaderAPI('Track_preorder_update'),
          }
        )
        .then(async (response) => {
          console.log("onSubmit form add", response);
          let rs = response.data;
          if (rs.status === true) {
            this.$swal("สำเร็จ", "แก้ไขใบพรีออร์เดอร์เรียบร้อย", "success").then(
              (result) => {
                this.$router.push("/pod/OrderList");
              }
            );
          } else {
            console.log("registerUser Fail");
            this.$swal("ผิดพลาด", "ไม่สามารถแก้ไขใบพรีออร์เดอร์ได้", "error");
            this.dataReady = true;
          }
          this.dataReady = true;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response.data.message) {
            this.$swal("ผิดพลาด", error.response.data.message, "error");
          } else {
            this.$swal("ผิดพลาด", "ไม่สามารถแก้ไขใบพรีออร์เดอร์ได้", "error");
          }
          this.dataReady = true;
        });
    },
    onAddOrder() {
      this.items.push(this.formProduct)
      this.$bvModal.hide('modalAddPreList')
    },
    getDataPreOrder (dt) {
      this.dataReady = false;
      this.items = [];

      this.totalRows = 0
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Track_preorder/Track_preorder_code_list?userName=' +
          this.userData.userName +
          '&trackPreorderCode=' +
          dt,
          {
            headers: this.getHeaderAPI('Track_preorder_code_list', this.userData.userName)
          }
        )
        .then((response) => {
          console.log('getDataTrackPreOrder', response.data)

          const rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              this.items = rs.data
              this.formPre.trackPreorderCode = rs.data[0].trackPreorderCode
              this.formPre.orderCode = rs.data[0].preorderCode
              this.formPre.userCode = rs.data[0].userCode
              this.formPre.shopChina = rs.data[0].shopChina
              this.formPre.trackCode = rs.data[0].shippingChinaCode.split(", ");
              this.totalRows = this.items.length
            } else {
              this.items = []
            }
          }

          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTrackPreOrder error:', error)
          this.dataReady = true
          this.items = []
        });
    },
    onEditOrder(index, data) {
      this.items = this.items.map((val, indexItem) => {
        if (indexItem === index){ 
          return data
        } else {
          return val
        }
      })
      // debugger
      this.$bvModal.hide('modalEditPreList')
    },
    editDataTrack(data, indexData) {
      this.formProductUpdate = {
        index: indexData,
        trackPreorderId: data.trackPreorderId,
        url: data.url,
        remark: data.remark,
      }

      this.$bvModal.show('modalEditPreList')
    },
    resetModal() {
      this.formProduct = {
        url: '',
        remark: '',
      }
    },
    getDataUser() {
      this.dataReady = false;
      let lsUser = this.getDataStorageUser();
      if (lsUser) {
        this.userData = lsUser;
        // this.form.userName = lsUser.userName;
        this.formPre.CREATE_USER = lsUser.userName;

        if (lsUser.userType === "U") {
          this.formPre.userCode = lsUser.userCode;
          this.checkMemCode();
        }
      } else {
        this.$router.push("/Login");
      }
    },
    checkMemCode() {
      console.log("checkMem Type", this.userData.userType);
      console.log("checkMem Code", this.userData.userCode);

      if (this.userData.userType === "U" && this.userData.userCode) {
        this.checkCode = false;
      } else {
        this.checkCode = true;
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

div.language-bar {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/PreOrder/OrderUpdate.vue